
<template>
    <Section>
        <header class="section__header section__toggle content-8-12">
            <h2>{{ title }} </h2>
            <transition name="fade-up-down" mode="out-in">
                <span v-if="hideAreaNav" style="margin-left: .75em;">({{ areas.length }} hidden)</span>
            </transition>
            <Button display="link" class="btn--toggle" @click="toggleHideShow($refs.slider.$el)">
                {{ hideAreaNav ? 'Show' : 'Hide' }} {{ title }} <iconArrow :direction="hideAreaNav ? 'down' : 'up'" />
            </Button>
        </header>

        <hooper
             :class="[
                'area-nav',
                {'container--hidden' : hideAreaNav },
                {'container--visible' : !hideAreaNav }
            ]"
            ref="slider"
            :settings="hooperSettings"
        >
            <slide
                v-for="({ name, path }, ind) in areas"
                :class="['area-nav__item', { 'area-nav__item--active' : isActive === ind}]"
                :key="`area-nav-${path}-${ind}`"
            >
                <button
                    class="area-nav__link"
                    role="link"
                    type="button"
                    @mousedown.prevent="setCurrentPosition"
                    @mouseup.prevent="checkClicked($event, path)"
                >
                    <span>{{ name }}</span>
                </button>
            </slide>

            <hooper-navigation slot="hooper-addons"></hooper-navigation>
        </hooper>
    </Section>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';
import { mapState, mapActions } from 'vuex'
import gsap from 'gsap'

export default {
    components: {
        Hooper,
        Slide,
        HooperNavigation
    },

    props: {
        title: { type: String, default: 'Areas' }
    },

    data() {
        return {
            dragging: false,
            hooperSettings: {
                pagination: "no",
                itemsToShow: 3.5,
                wheelControl: false,
                breakpoints: {
                    1100: {
                        itemsToShow: 5.5
                    },
                    1500: {
                        itemsToShow: 7.5
                    }
                }
            },
            currentSlide: null,
            oldElPosition: null
        }
    },

    mounted () {
        // Get the index of the matching slide, and make that one visible
       this.$refs.slider.slideTo(this.getActiveAreaIndex())
       if (this.hideAreaNav) this.$refs.slider.$el.style.height = 0
    },

    computed: {
        ...mapState('Resources', ['areas']),
        ...mapState('App', ['hideAreaNav']),

        isActive () {
            return this.getActiveAreaIndex()
        }
    },

    methods: {
        ...mapActions('App', ['toggleHideAreaNav']),

        getActiveAreaIndex () {
            const matchPath = ({ path }) => path === this.$route.params.area
            return this.areas && this.areas.findIndex(matchPath)
        },
        /*
            We don't want pages to load accidently if a user is "dragging" the slider,
            and don't have access to the "is-draggin" prop. 'drag-start' is no luck either.
            So we set the elements position on mouse down. On mouse-up, if the
            el has moved, then the user has dragged it - if it hasn't, the use has clicked
            and we should redirect them to the new area/page
            @mousedown = setCurrentPosition
            @mouseup = checkClicked
        */
        setCurrentPosition (event) {
            this.oldElPosition = event.target.getBoundingClientRect().x
        },

        checkClicked (event, path) {
            const finalPosition = event.target.getBoundingClientRect().x
            const matchesOldPosition = finalPosition == this.oldElPosition
            const isCurrentPath = this.$route.params.area === path
            const toRoute = { name: 'area', params: { area: path } }

            // object hasn't moved/slid - so take them to the page they've clicked
            if (matchesOldPosition && !isCurrentPath) this.$router.push(toRoute)
        },

        toggleHideShow (el) {
            const height = this.hideAreaNav ? 'auto' : 0

            this.toggleHideAreaNav()

            gsap.to(el, {
                duration: .25,
                height,
                ease: 'power4.out'
            })
        }
    },
}
</script>
